/**
 * File: main.tsx
 * Description: Application entry point. Mounts the React app inside the DOM root element, wrapping it with StrictMode and BrowserRouter to enable routing.
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from '@/App.js'
import { BrowserRouter } from 'react-router-dom'

const rootElement = document.getElementById('root')
// Fail fast if the HTML template is missing the #root element rather than rendering into null.
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
